<template lang="pug">
.container
    b-navbar#nav(type="is-white", spaced)
        template(slot="brand")
            b-navbar-item(tag="div", :to="{ path: '/' }")
              router-link(:to="{ path: '/' }")
                img(src="@/assets/logo.png")
        template(slot="end")
            b-navbar-item(tag="router-link", :to="{ path: '/video' }") Videos
            b-navbar-item(tag="router-link", :to="{ path: '/podcast' }") Podcast
            b-navbar-item(tag="router-link", :to="{ path: '/articles' }") Articles
            b-navbar-item(tag="router-link", :to="{ path: '/charity' }") Support
            b-navbar-item(tag="router-link", :to="{ path: '/team' }") Team
            b-navbar-item(tag="router-link", :to="{ path: '/contact' }") Contact
            b-navbar-item(tag="a", @click="openInstagram")
                a(href="https://www.instagram.com/fanfairmedia/", target="_blank")
                    font-awesome-icon(:icon="['fab', 'instagram']")
            b-navbar-item(tag="a", @click="openYoutube")
                a(href="https://www.youtube.com/user/TheShowstopper76", target="_blank")
                    font-awesome-icon(:icon="['fab', 'youtube']")
            b-navbar-item(tag="a", @click="openTwitter")
                a(href="https://twitter.com/FanfairMedia", target="_blank")
                    font-awesome-icon(:icon="['fab', 'twitter']")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTwitter,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";

library.add(faTwitter, faInstagram, faYoutube);

export default {
  name: "Navbar",

  methods: {
    openInstagram() {
      window.open("https://www.instagram.com/fanfairmedia/", "_blank");
    },

    openYoutube() {
      window.open("https://www.youtube.com/user/TheShowstopper76", "_blank");
    },

    openTwitter() {
      window.open("https://twitter.com/FanfairMedia", "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: black;
}
</style>
